export default "__VITE_ASSET__05bd140f__"